import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PagerService from "../services/pager";

type PagerProps = { onChange: () => void }

export default function Pager({onChange}: PagerProps) {

    function changePage(sens: number) {
        PagerService.changePage(sens)
        if (onChange) {
            onChange();
        }
    }

    if (PagerService.getPageSize() < 1) {
        return null
    }
    return (
        <>
            <div className="pointer" style={{height: '20px'}}>
                <FontAwesomeIcon icon="caret-left" onClick={() => changePage(-10)}/>
                <FontAwesomeIcon icon="caret-left" onClick={() => changePage(-10)}/>
            </div>
            <div className="pointer" style={{height: '20px'}}>
                <FontAwesomeIcon icon="caret-left" onClick={() => changePage(-1)}/>
            </div>
            {PagerService.getCurrentPage()+1}/{PagerService.getLastFilteredPage()}({PagerService.getLastTotalPage()})
            <div className="pointer" style={{height: '20px'}}>
                <FontAwesomeIcon icon="caret-right" onClick={() => changePage(1)}/>
            </div>
            <div className="pointer" style={{height: '20px'}}>
                <FontAwesomeIcon icon="caret-right" onClick={() => changePage(10)}/>
                <FontAwesomeIcon icon="caret-right" onClick={() => changePage(10)}/>
            </div>
        </>
    );
}
